<template>
  <div class="con">
    <div class="line1"></div>
    <div class="footer">
      <div class="left">
        <div class="Bottom_uilist">
          <div class="item">
            <p class="href_a">{{ $t('nav.about') }}</p>
            <ul>
              <li><a :href="localePath('/about?tab=0')">{{ $t('nav.enterprise') }}</a></li>
              <li><a :href="localePath('/about?tab=1')">{{ $t('nav.starTeam') }}</a></li>
              <li><a :href="localePath('/about?tab=2')">{{ $t('nav.development') }}</a></li>
              <li><a :href="localePath('/about?tab=3')">{{ $t('nav.honor') }}</a></li>
              <li><a :href="localePath('/about?tab=4')">{{ $t('nav.contactInfo') }}</a></li>
            </ul>
          </div>
          <div class="item">
            <p class="href_a">{{ $t('nav.product') }}</p>
            <ul>
              <li><a :href="localePath('/product?tab=0')">{{ $t('nav.ruichangtai') }}</a></li>
              <li><a :href="localePath('/product?tab=1')">{{ $t('nav.equipment') }}</a></li>
              <li><a :href="localePath('/product?tab=2')">{{ $t('nav.research') }}</a></li>
              <li><a :href="localePath('/product?tab=3')">{{ $t('nav.reagent') }}</a></li>
              <!-- <li><a href="/product?tab=4">{{ $t('nav.cellCulture') }}</a></li> -->
            </ul>
          </div>
          <div class="item">
            <p class="href_a">{{ $t('nav.health') }}</p>
            <ul>
              <li><a :href="localePath('/health')">{{ $t('nav.productGuide') }}</a></li>
              <li><a :href="localePath('/health')">{{ $t('nav.expertScience') }}</a></li>
            </ul>
          </div>
          <div class="item">
            <p class="href_a">{{ $t('nav.contact') }}</p>
            <ul>
              <li><a :href="localePath('/contact?tab=1')">{{ $t('nav.recruit') }}</a></li>
              <li><a :href="localePath('/contact?tab=0')">{{ $t('nav.contactInfo') }}</a></li>
            </ul>
          </div>
          <div class="item">
            <p class="href_a">{{ $t('nav.newsCenter') }}</p>
            <ul>
              <li><a :href="localePath('/newsCenter')">{{ $t('nav.newsCenter') }}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="@/assets/img/gbh_logo.jpg" alt="" />
        <div class="code">
          <img class="code1" src="@/assets/img/code_1.png" alt="" />
          <img class="code2" src="@/assets/img/code_2.png" alt="" />
        </div>
      </div>
    </div>
    <!-- <div class="line2"></div> -->
    <div class="footer_txt">
      {{ $t('footer.copyright') }}
    </div>
  </div>
</template>

<script setup>
const localePath = useLocalePath()
</script>

<style lang="less" scoped>
.con {
  /* 页脚根元素不能用 absolute：首页末屏依赖 fp-auto-height 按内容撑高，
     absolute 会脱离文档流导致该区块高度为 0，页面总高不含页脚，
     最后一个导航点滚不到真正底部；改用静态定位并保留顶部微偏移 */
  position: relative;
  width: 100%;
  padding-top: 20px;
  .line1 {
    position: absolute;
    background: linear-gradient(
      to right,
      rgba(0, 160, 233, 1),
      rgba(255, 241, 0, 1)
    );
    height: 2px;
    width: 100%;
    // margin-top: 10px;
  }
  .footer {
    background-color: #fff;
    display: flex;
    .left {
      display: flex;
      justify-content: space-evenly;
      flex: 6;
      padding-top: 20px;
      margin-left: 50px;
      .Bottom_uilist {
        display: flex;
        justify-content: space-between;
        .item {
          margin-right: 20px;
          .href_a {
            margin-bottom: 12px;
            font-weight: 900;
            color: #666666;
          }
        }
        ul {
          list-style: none;
          a {
            font-size: 6px;
            color: #999;
            line-height: 16px;
            text-decoration: none;
            &:hover {
              color: #3d74e9;
              font-weight: 700;
              // opacity: 1;
            }
          }
        }
      }
    }
    .right {
      flex: 4;
      img {
        width: 70px;
        height: 33px;
        // margin-bottom: 10px;
        margin-top: 20px;
      }
      .code {
        margin-bottom: 20px;
        .code1 {
          width: 32px;
          height: 41px;
          margin-right: 10px;
        }
        .code2 {
          width: 102px;
          height: 41px;
        }
      }
    }
  }
  .line2 {
    width: 653px;
    height: 1px;
    background: #ececec;
    margin: 0 auto;
  }
  .footer_txt {
    font-size: 7px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #333333;
    opacity: 0.58;
    text-align: center;
    padding-top: 10px;
    position: relative;
    margin-bottom: 20px;
  }
}
</style>
